import { observer } from "mobx-react-lite";
import * as React from "react";
import { $framework, LinkedSourcePicker, useOpenDashApp, useSource, } from "../..";
import * as Layout from "./components";
export const breakpoint = 600;
export const HeaderSourcePicker = observer(function HeaderSourcePicker({ mobile: isMobile, style, }) {
    const app = useOpenDashApp();
    const [source, setSource, sources] = useSource();
    if (!sources || sources.length === 0) {
        return null;
    }
    if (isMobile) {
        if (app.ui2.headerWidth >= breakpoint) {
            return null;
        }
        return (React.createElement(Layout.HeaderRow, null,
            React.createElement(LinkedSourcePicker, { asButton: true, style: { width: "100%", height: "var(--opendash-header-row-height)" } })));
    }
    if (source && sources.length === 1) {
        return (React.createElement("span", { style: { color: "var(--opendash-color-darkgray)", userSelect: "none" } }, source.name));
    }
    return (React.createElement(LinkedSourcePicker, Object.assign({ asButton: false, style: style }, $framework.ui.headerSourcePickerProps)));
});
//# sourceMappingURL=HeaderSourcePicker.js.map